const COUPON_COOKIE_PREFIX = "coupon_";

const getCookie = (name: string): string | null => {
	const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
	return match ? decodeURIComponent(match[2]) : null;
};

export const setCouponCookie = (userId: string, coupon: string) => {
	document.cookie = `${COUPON_COOKIE_PREFIX}${userId}=${encodeURIComponent(coupon)}; path=/; max-age=${60 * 60 * 24 * 30}; SameSite=Lax`;
};

export const getCouponCookie = (userId: string): string | null => getCookie(COUPON_COOKIE_PREFIX + userId);

export const removeCouponCookie = (userId: string) => {
	document.cookie = `${COUPON_COOKIE_PREFIX}${userId}=; path=/; max-age=0; SameSite=Lax`;
};
